import { Avatar, Divider, Tooltip, Typography } from '@material-ui/core'
import { AvatarGroup } from '@material-ui/lab'
import { format } from 'date-fns'
import { isEmpty } from 'lodash'
import React from 'react'

const FriendsOrdered = ({ friendImageUrlBase, friendsOrdered }) => {
  const maxFriendBubbles = 3
  const additionalFriendsOrderCount = friendsOrdered.length - maxFriendBubbles

  return (
    <>
      <Typography className="-friendsTitle" variant="body2">
        Ordered by
      </Typography>
      <AvatarGroup className="-avatarGroup" style={{ zIndex: 1 }}>
        {friendsOrdered.slice(0, maxFriendBubbles).map(friendOrdered => {
          const friend = friendOrdered.friend
          const name = `${friend.firstName} ${friend.lastName}`
          const initials =
            `${isEmpty(friend.firstName) ? '?' : friend.firstName[0].toUpperCase()}` +
            `${isEmpty(friend.lastName) ? '?' : friend.lastName[0].toUpperCase()}`
          return (
            <Tooltip key={friend.userId} title={name}>
              <Avatar
                alt={name}
                src={
                  friend.avatarId &&
                  encodeURI(
                    `${friendImageUrlBase}/profiles/${friend.avatarId}.jpg?height=50&width=50`,
                  )
                }
                variant="circular"
              >
                {initials}
              </Avatar>
            </Tooltip>
          )
        })}
        {additionalFriendsOrderCount > 0 && <Avatar>+ {additionalFriendsOrderCount}</Avatar>}
      </AvatarGroup>
    </>
  )
}

const RestaurantDeliveryDetail = ({
  cutoffTime,
  cutoffDisplay,
  dropoffDisplay,
  friendsOrdered,
  friendImageUrlBase,
}) => {
  const shortFormat = 'h:mm A'
  return (
    <>
      <div className="-soldOutContent">
        <p className="-soldOutTitle">Sold Out!</p>
        <p className="-soldOutCopy">
          This restaurant only accepts a certain amount of orders to ensure quality.
        </p>
      </div>
      <div className="-tooLateContent">
        <p className="-tooLateTitle">Sorry, it’s too late.</p>
        <p className="-tooLateCopy">
          This restaurant stopped accepting orders at {format(cutoffTime, shortFormat)}.
        </p>
      </div>
      <p className="-cutOffContent">Hurry, time is running out!</p>
      <div className="-orderTime">
        <Typography className="-timeTitle" variant="body2">
          Order by
        </Typography>
        <p className="-time">{cutoffDisplay}</p>
      </div>
      <Divider className="-divider" flexItem light orientation="vertical" />
      <div className="-deliveryTime">
        <div>
          <Typography className="-timeTitle" variant="body2">
            Est. Delivery
          </Typography>
          <p className="-time">{dropoffDisplay}</p>
        </div>
      </div>
      {!isEmpty(friendsOrdered) && (
        <>
          <Divider className="-divider" flexItem light orientation="vertical" />
          <div className="-friendsOrdered">
            <FriendsOrdered
              friendImageUrlBase={friendImageUrlBase}
              friendsOrdered={friendsOrdered}
            />
          </div>
        </>
      )}
    </>
  )
}

export default RestaurantDeliveryDetail
